module.exports = __webpack_public_path__ + "assets/img/ar2.c87ea037.svg";